import NextLink from "@/components/shared/NextLink";
import colors from "@/theme/colors";
import styled from "@emotion/styled";
import { Box, Breadcrumbs } from "@mui/material";
import Image from "next/image";
type Props = {
  parents: { title: string; url: string }[];
};

const StyledLink = styled(NextLink)({
  color: colors.black,
  textDecoration: "none",
});
export function CustomBreadcrumbs({ parents }: Props) {
  return (
    <Box>
      <Breadcrumbs
        separator={
          <Image src="/assets/arrowLeft.svg" alt="arrow" width={8} height={8} />
        }
        aria-label="מיקומך בדפי האתר"
      >
        {parents.map((item, index) => (
          <StyledLink key={index} href={item.url}>
            {item.title}
          </StyledLink>
        ))}
      </Breadcrumbs>
    </Box>
  );
}
